import {FixedRatioContainer, SkeletonBlock} from '@aboutyou/ui-components';
import React from 'react';

export const BrandPageHeaderLoading: React.FC<{landscape?: boolean}> = ({
  landscape,
}) => {
  return (
    <FixedRatioContainer ratio={landscape ? '4:1' : '5:4'}>
      <SkeletonBlock $width="100%" $height="100%" />
    </FixedRatioContainer>
  );
};
